import React from "react";

const SvgComponent = props => (
  <svg
    viewBox="0 0 512 512"
    style={{ width: "5em", height: "5em", margin: "36px auto 0" }}
    display="block"
    {...props}
  >
    <path
      d="M148.037 189.847H364.34M148.037 259.647H364.34m-216.303 69.8H364.34"
      fill="none"
      stroke="currentColor"
      strokeWidth={18}
      strokeLinecap="round"
    />
  </svg>
);

export default SvgComponent;



// WEBPACK FOOTER //
// ./images/hamburger.svg